import React, { memo } from 'react'

import Text from '../text/Text'
import DisplayLabelFormat from './DisplayLabelFormat'

const DisplayLabel = ({ label, value }) => {
  return (
    <DisplayLabelFormat
      label={label}
      value={
        <Text
          label={value}
          variant='caption'
          component='div'
          sx={{ maxHeight: 96, overflow: 'auto', lineHeight: 1.3 }}
        />
      }
    />
  )
}

export default memo(DisplayLabel)
